import { assert } from '@varos/util-typescript';
import { ChatLoaderBaseConfig } from '../../../base';
import { CallRequestDetailLoader } from './callRequestDetailInterface';
import { CallRequestDetailAggregate } from './callRequestDetailModel';
import { useMemo } from 'react';
import { CallAggregate } from '@varos/call-core';
import { AssistantContext } from '@varos/assistant-react';
import { ThreadDetailAggregate } from '../../../thread';
import { MessageItemAggregate } from '../../../message';

export function createCallRequestDetailLoader(
    config: ChatLoaderBaseConfig
): CallRequestDetailLoader {
    const { repository } = config;
    return {
        useLoad(context, props): CallRequestDetailAggregate {
            const thread = useMemo((): ThreadDetailAggregate => {
                return {
                    thread: props.item.thread.thread,
                    messages: props.item.thread.messages.map(
                        (msg): MessageItemAggregate => ({
                            definition: props.item.definition,
                            instance: props.item.integration,
                            message: msg.message,
                        })
                    ),
                    integration: props.item.integration,
                    definition: props.item.definition,
                };
            }, [props.item.thread, props.item.definition, props.item.integration]);

            return {
                integration: props.item.integration,
                definition: props.item.definition,
                thread,
                context: props.item.context,
                // tool: props.tool,
                // call,
            };
        },
    };
}
